import { render, staticRenderFns } from "./SolicitudEntreSedes.vue?vue&type=template&id=4f7af924&scoped=true"
import script from "./SolicitudEntreSedes.vue?vue&type=script&lang=js"
export * from "./SolicitudEntreSedes.vue?vue&type=script&lang=js"
import style0 from "./SolicitudEntreSedes.vue?vue&type=style&index=0&id=4f7af924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7af924",
  null
  
)

export default component.exports